module.exports = __webpack_public_path__ + "img/google-lighthouse.ccd4d593.png";